import { render, staticRenderFns } from "./newcategory.vue?vue&type=template&id=2bff68f2&scoped=true"
import script from "./newcategory.vue?vue&type=script&lang=js"
export * from "./newcategory.vue?vue&type=script&lang=js"
import style0 from "./newcategory.vue?vue&type=style&index=0&id=2bff68f2&prod&scoped=true&lang=css"
import style1 from "./newcategory.vue?vue&type=style&index=1&id=2bff68f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bff68f2",
  null
  
)

export default component.exports